"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DatePick = DatePick;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _Today = _interopRequireDefault(require("@material-ui/icons/Today"));

var _pickers = require("@material-ui/pickers");

var _DateTimePicker = _interopRequireDefault(require("../../DateTimePicker"));

var _moment = _interopRequireDefault(require("moment"));

var _react = _interopRequireWildcard(require("react"));

function DatePick(props) {
  var name = props.name,
      _onChange = props.onChange,
      format = props.format,
      _props$defalutText = props.defalutText,
      defalutText = _props$defalutText === void 0 ? 'mm/dd/yyyy' : _props$defalutText,
      value = props.value,
      rest = (0, _objectWithoutProperties2["default"])(props, ["name", "onChange", "format", "defalutText", "value"]);

  var _useState = (0, _react.useState)(value),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      dateTime = _useState2[0],
      setDateTime = _useState2[1];

  var textNode = (0, _react.useMemo)(function () {
    return dateTime.valueOf() ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (0, _moment["default"])(dateTime).format(format)) : /*#__PURE__*/_react["default"].createElement("div", {
      className: "text-ultra-light"
    }, defalutText);
  }, [dateTime]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex relative date-pill items-center justify-between w-full px-4 py-2 border rounded"
  }, textNode, /*#__PURE__*/_react["default"].createElement(_Today["default"], {
    className: "text-gray-light"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "opacity-0 absolute inset-0 z-10"
  }, /*#__PURE__*/_react["default"].createElement(_DateTimePicker["default"], (0, _extends2["default"])({
    autoOk: true,
    field: false,
    disableToolbar: true,
    variant: "inline",
    className: "w-full h-full",
    PopoverProps: {
      elevation: 1
    },
    picker: _pickers.DatePicker,
    name: name,
    format: format,
    onChange: function onChange(value) {
      setDateTime(value);

      _onChange(value.unix());
    }
  }, rest))));
}
//# sourceMappingURL=DatePick.js.map